import { Reveal } from "./Reveal";

export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_3e8a6104-20ab-4fbb-976f-9044dce1c41d/artifacts/4labvuka_Gemini_Generated_Image_w56g2cw56g2cw56g.png";

export const Hero = () => (
  <section
    id="top"
    data-testid="hero-section"
    className="relative overflow-hidden"
  >
    <div className="mx-auto flex max-w-6xl flex-col items-center px-6 pb-24 pt-20 sm:pt-28">
      <Reveal>
        <img
          src={LOGO_URL}
          alt="Lakeview Music logo — a pine tree, mountain ridges and a lake drawn in ink"
          data-testid="hero-logo"
          className="w-56 sm:w-72 md:w-80"
        />
      </Reveal>
      <Reveal delay={0.15}>
        <p
          data-testid="hero-tagline"
          className="mt-6 text-xs font-medium tracking-[0.35em] uppercase text-foreground/60"
        >
          Music Consulting &amp; Management
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <p className="mt-10 max-w-xl text-center text-base leading-relaxed text-foreground/80">
          Lakeview Music is an independent music consulting and management
          company — steady guidance for artists, writers, and the people who
          back them.
        </p>
      </Reveal>
      <Reveal delay={0.35}>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
          <a
            href="#contact"
            data-testid="hero-cta-contact"
            className="border border-primary bg-primary px-8 py-4 text-xs font-medium tracking-[0.2em] uppercase text-primary-foreground transition-colors duration-300 hover:bg-secondary hover:text-secondary-foreground"
          >
            Work with us
          </a>
          <a
            href="#services"
            data-testid="hero-cta-services"
            className="link-underline px-2 py-4 text-xs font-medium tracking-[0.2em] uppercase text-foreground/70 hover:text-foreground"
          >
            Explore services
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
